import React, { Component } from "react";
import logo from "../../../services/images/brand/12341035_1049823068395667_8370818913768157705_n.png";

class Navigation extends Component {
  componentDidMount() {
    window.addEventListener("scroll", () => {
      // Add wood bg + clear active
      if (window.scrollY < 1) {
        document.getElementById("mainNav").classList.remove("affix");
        let list = document.getElementsByClassName("navButtonGroup");
        //added to remove active class from all a elements
        for (let i = 0; i < list.length; i++) {
          list[i].classList.remove("active");
        }
      } else {
        if (!document.getElementById("mainNav").classList.contains("affix")) {
          document.getElementById("mainNav").className += " affix";
        }
      }

      // Set active scroll item
      if (window.scrollY > 100) {
        let scrollPos = window.scrollY;
        let navBarHeight = document.getElementById("mainNav").offsetHeight;
        let list = document.getElementsByClassName("navButtonGroup");

        for (let i = 0; i < list.length; i++) {
          let currLink = list[i];
          let id = currLink.getAttribute("name");
          let refElement = document.getElementById(id);
          if (refElement.offsetTop <= scrollPos + navBarHeight + 500) {
            for (let i = 0; i < list.length; i++) {
              list[i].classList.remove("active"); //added to remove active class from all a elements
            }
            currLink.classList.add("active");
          } else {
            currLink.classList.remove("active");
          }
        }
      }
    });
  }

  render() {
    return (
      <nav
        id="mainNav"
        className="navbar navbar-default navbar-custom navbar-fixed-top"
      >
        <div className="container">
          <div className="navbar-header page-scroll">
            <button
              type="button"
              className="navbar-toggle"
              data-toggle="collapse"
              data-target="#bs-example-navbar-collapse-1"
              onClick={() => {
                let target = document.getElementById(
                  "bs-example-navbar-collapse-1",
                );
                if (target.classList.contains("in")) {
                  target.classList.remove("navGroupBig", "in");
                } else {
                  target.classList.add("navGroupBig", "in");
                }
              }}
            >
              <span className="sr-only">Toggle navigation</span>
              <i className="fa fa-bars" />
            </button>
            <a
              className="navbar-brand page-scroll"
              style={{ cursor: "pointer" }}
              onClick={() => {
                document.getElementById("header").scrollIntoView({
                  block: "center",
                  behavior: "smooth",
                });
              }}
            >
              {" "}
              <img id="llogo" className="img-responsive llogo" src={logo} />
            </a>
          </div>
          <div
            className="navbar-collapse navGroupHandle"
            id="bs-example-navbar-collapse-1"
          >
            <ul className="nav navbar-nav navbar-right">
              <li className="hidden">
                <a href="#page-top" />
              </li>
              <li className="navButtonGroup" name="events">
                <a
                  className="page-scroll"
                  style={{ cursor: "pointer" }}
                  id={"eventsButton"}
                  onClick={() => {
                    document.getElementById("events").scrollIntoView({
                      block: "start",
                      behavior: "smooth",
                    });
                    document
                      .getElementById("bs-example-navbar-collapse-1")
                      .classList.remove("navGroupBig", "in");
                  }}
                >
                  Events
                </a>
              </li>
              <li className="navButtonGroup" name="menu">
                <a
                  className="page-scroll"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    document.getElementById("menu").scrollIntoView({
                      block: "start",
                      behavior: "smooth",
                    });
                    document
                      .getElementById("bs-example-navbar-collapse-1")
                      .classList.remove("navGroupBig", "in");
                  }}
                >
                  menu
                </a>
              </li>
              <li className="navButtonGroup" name="google-map">
                <a
                  className="page-scroll"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    document.getElementById("google-map").scrollIntoView({
                      block: "start",
                      behavior: "smooth",
                    });
                    document
                      .getElementById("bs-example-navbar-collapse-1")
                      .classList.remove("navGroupBig", "in");
                  }}
                >
                  Map
                </a>
              </li>
              <li className="navButtonGroup" name="about">
                <a
                  className="page-scroll"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    document.getElementById("about").scrollIntoView({
                      block: "start",
                      behavior: "smooth",
                    });
                    document
                      .getElementById("bs-example-navbar-collapse-1")
                      .classList.remove("navGroupBig", "in");
                  }}
                >
                  About
                </a>
              </li>
              <li className="navButtonGroup" name="contact">
                <a
                  className="page-scroll"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    document.getElementById("contact").scrollIntoView({
                      block: "start",
                      behavior: "smooth",
                    });
                    document
                      .getElementById("bs-example-navbar-collapse-1")
                      .classList.remove("navGroupBig", "in");
                  }}
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/scenes/landingPage/components/Navigation.js